import permissions from 'application/detail/permissions.json';
import DefaultAvatar from 'assets/img/icons/avatar-default.png';
import { CrossAppFeatures } from 'modules/shared/featureToggle/CrossAppFeatures';
import { blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, portalDomain, } from 'app.constants';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { FeatureToggleClientService } from 'feature-toggle-client';
import { aiAgentsStateName } from './aiAgents';
import { builderObservabilityStateName } from './builderObservability';
import { AttendanceFeatures } from './attendance/AttendanceFeatures';
export const UnauthorizedAccessEvent = 'unauthorizedAccess';
export class DetailApplicationController {
    static $inject = ['AccountService2', 'PermissionsService', 'SidebarConfigsService', 'application', '$rootScope', '$state', 'BLIPWEBURI', 'AuthenticationService', 'TranslateService'];
    constructor(AccountService2, PermissionsService, SidebarConfigsService, application, $rootScope, $state, BLIPWEBURI, AuthenticationService, TranslateService) {
        'ngInject';
        this.AccountService2 = AccountService2;
        this.PermissionsService = PermissionsService;
        this.SidebarConfigsService = SidebarConfigsService;
        this.application = application;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.BLIPWEBURI = BLIPWEBURI;
        this.AuthenticationService = AuthenticationService;
        this.TranslateService = TranslateService;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.portalDomain = portalDomain;
        this.blipWebUri = this.BLIPWEBURI.replace('%identifier', application.shortName).replace('%accessKey', application.accessKey);
        // workaround so that the avatar image on the sidenav falls back to the
        // default avatar image in case `imageUri` is undefined, because `ng-src`
        // does not change in case the value is null/undefined.
        this.defaultAvatar = DefaultAvatar;
        //Set view permissions object
        this.setPermissions(permissions);
        this._checkStatePermissions();
        this.init();
    }
    async $onInit() {
        this.account = await this.AccountService2.me();
        const userToken = this.AuthenticationService.token;
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        this.language = this.TranslateService.getCurrentLanguage();
        this.token = useDelegation ? userToken : this.application.accessKey;
        this.authEmail = this.AuthenticationService.email;
        this.cluster = this.application.cluster;
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
    }
    get isContactsPage() {
        return this.$state.current.name === 'auth.application.detail.users';
    }
    get isAiAgentsPage() {
        return this.$state.current.name.startsWith(aiAgentsStateName);
    }
    get isBuilderObservabilityPage() {
        return this.$state.current.name.startsWith(builderObservabilityStateName);
    }
    get isArtificialIntelligencePage() {
        return this.$state.current.name === 'auth.application.detail.artificialIntelligence';
    }
    get shouldFooterVisible() {
        if (window.location.pathname.indexOf('/templates/builder') > -1) {
            return false;
        }
        if (window.location.pathname.indexOf('/templates/pipeline') > -1) {
            return false;
        }
        if (window.location.pathname.indexOf('/attendance/desk') > -1 && this.isAttendanceMenuMfeEnabled) {
            return false;
        }
        if (this.useFooterWithBlipStatus && this.isArtificialIntelligencePage) {
            return false;
        }
        return true;
    }
    async checkFeatures() {
        this.useFooterWithBlipStatus = await CrossAppFeatures.useFooterWithBlipStatus();
        this.isAttendanceMenuMfeEnabled = await AttendanceFeatures.isAttendanceMenuMfeEnabled();
    }
    get areaClass() {
        return `area-${this.$state.params.area}`;
    }
    async init() {
        try {
            this.configsItems = await this.SidebarConfigsService.getMenuItems(this.application.template);
            this.me = await this.AccountService2.me();
            await this.checkFeatures();
        }
        catch (e) {
            console.error(e);
        }
    }
    broadcastSidenavEvent() {
        this.$rootScope.$broadcast('SideNavToggleExpand2');
    }
    setPermissions(permissions) {
        this.permissions = Object.keys(permissions).reduce((object, permissionName) => ({
            ...object,
            [permissionName]: this.application.applicationUserPermissionModel.some((p) => p.permissionClaim === permissions[permissionName].claim),
        }), {});
    }
    goToBlipWeb(preventDefault) {
        if (this.hasConfigPermission && preventDefault == true) {
            window.open(this.blipWebUri, '_blank');
        }
    }
    isTemplate() {
        return !this.isDevApplication();
    }
    isDevApplication() {
        return (this.application.template === 'undefined' ||
            this.application.template == 'webhook');
    }
    //
    async _checkStatePermissions() {
        //This var is used on DetailApplicationView, for verify permissions on submenu of Configurations
        this.hasConfigPermission = await this.PermissionsService.hasPermissions('write', 'configurations');
    }
}
DetailApplicationController.$inject = ['AccountService2', 'PermissionsService', 'SidebarConfigsService', 'application', '$rootScope', '$state', 'BLIPWEBURI', 'AuthenticationService', 'TranslateService'];
